import { call, put } from "redux-saga/effects";
import axios from "../../axios-local-api";
import * as actions from "../actions";
import packageJson from "../../../package.json";

export function* initWanSaga() {
	const sessionToken = yield sessionStorage.getItem("sessionToken");
	if (sessionToken) {
		yield put(actions.initWanStart());
		try {
			const wanEndpoint = yield { method: "get", url: "/wan" };
			const { data: wanData } = yield axios.get('/wan');

			yield call([sessionStorage, "setItem"], "vendorModel", wanData.model);
			yield put(actions.setWan(wanData));
		} catch (error) {
			yield put(actions.fetchWanFailed());
		}
	} else {
		//console.log("NO TOKEN");
	}
}

export function* checkWanSaga(action) {
	const rMac = action.rMac;
	const token = action.token;
	const sessionToken = action.sessionToken;
	function delay(ms) {
		return new Promise((resolve) => setTimeout(resolve, ms));
	}
	yield delay(action.wait);
	if (sessionToken) {
		try {
			const { data: response } = yield axios.get("/wan");

			if (response.connectionState && response.connectionState === "connected") {
				yield put(actions.wanConnected());
				yield put(actions.getAll());
			} else {
				yield put(actions.checkWan(rMac, token, sessionToken, packageJson.reCheckWanWait));
			}
		} catch (error) {
			yield put(actions.fetchWanFailed());
		}
	} else {
		//console.log("NO TOKEN");
	}
}

export function* runWifiServiceCheckSaga() {
	try {
		yield put(actions.wifiServiceCheckSpinnerUpdate());
		yield put(actions.initWanStart());
		yield put(actions.initWan());
		yield put(actions.getQoeScores());
		yield put(actions.initEquipment());
	} catch (error) {
		console.error("Error fetching WSC data.", error);
		yield put(actions.fetchWscFailed(error));
	}
}
